if ( typeof CollectionLoadMore !== 'function' ) {

	class CollectionLoadMore extends HTMLElement {

		connectedCallback() {

			this.sectionId = this.dataset.sectionId;

			const nextLink = this.querySelector('.pagination a.next');
			if ( ! nextLink ) return;

			this._nextUrl = nextLink.href;

			// .pagination sets its own `display: flex` in component-pagination.css,
			// which (being an author stylesheet rule) overrides the `hidden`
			// attribute's user-agent-stylesheet `display: none` regardless of
			// specificity - so this has to be an inline style to actually win.
			const paginationEl = this.querySelector('.pagination');
			if ( paginationEl ) paginationEl.style.display = 'none';

			this._button = document.createElement('button');
			this._button.type = 'button';
			this._button.className = 'button button--solid load-more-button';
			this._button.textContent = this.dataset.loadMoreText || 'Load More';
			this._button.addEventListener('click', () => this.loadNext());
			this.appendChild(this._button);

		}

		loadNext() {

			if ( this._loading || ! this._nextUrl ) return;
			this._loading = true;

			// Whatever is moving the page here (three attempts at the actual
			// mechanism - CSS scroll anchoring, disabled-button blur, focus
			// retention across the reflow - have all failed to explain it), the
			// customer's scroll position is captured up front and forced back
			// to this exact value after the new cards land. Restored twice
			// (immediately, and again shortly after) in case whatever causes
			// the jump fires slightly later than the DOM update itself.
			const scrollYBeforeLoad = window.scrollY;

			// blur() kept for good measure - documented to never itself cause a
			// scroll, and there's no reason for the button to hold focus while
			// it's mid-fetch.
			this._button.blur();

			// aria-disabled + pointer-events (rather than the native `disabled`
			// property) so nothing here touches real focus a second time - the
			// `_loading` flag above already blocks a second click regardless.
			this._button.setAttribute('aria-disabled', 'true');
			this._button.classList.add('is-loading');
			this._button.textContent = this.dataset.loadingText || 'Loading...';

			const fetchUrl = new URL(this._nextUrl, window.location.origin);
			fetchUrl.searchParams.set('section_id', this.sectionId);
			const targetUrl = new URL(this._nextUrl, window.location.origin);

			fetch(fetchUrl.toString())
				.then(response => {
					if ( ! response.ok ) throw new Error('Request failed');
					return response.text();
				})
				.then(html => {

					const parsed = new DOMParser().parseFromString(html, 'text/html');
					const newGrid = parsed.getElementById('CollectionProductGrid');
					if ( ! newGrid ) throw new Error('No grid in response');

					// Every product card - whether it was one of the "first 4" or
					// the rest on the fetched page - shares this wrapper class, so
					// grabbing all of them (rather than replaying the fetched
					// page's own first-4/rest split) avoids re-rendering that
					// page's collection heading/banner block into the middle of
					// the grid.
					const newCards = [...newGrid.querySelectorAll('.box__collection')];

					// .sale-size-block__grid (the sandals page's size-filtered "Upto
					// 70% Off" row, rendered inside this same wrapper) is never a
					// place for the next page's cards.
					const containers = document.querySelectorAll('#main-collection-product-grid .product-grid-border-fix:not(.sale-size-block__grid)');
					const target = containers[containers.length - 1];

					if ( target && newCards.length ) {
						newCards.forEach(card => target.appendChild(card));
						// Row-border CSS keys off this container's own child count
						// mod 4 (see component-product-item.css), which is exactly
						// what changed by appending - not the collection's total.
						target.dataset.count = target.querySelectorAll(':scope > .box__collection').length % 4;
					}

					const newNextLink = newGrid.querySelector('.pagination a.next');
					this._nextUrl = newNextLink ? newNextLink.href : null;

					if ( this._nextUrl ) {
						this._button.removeAttribute('aria-disabled');
						this._button.classList.remove('is-loading');
						this._button.textContent = this.dataset.loadMoreText || 'Load More';
					} else {
						this._button.remove();
					}

					history.pushState({ searchParams: targetUrl.search.slice(1) }, '', targetUrl.pathname + targetUrl.search);

					setTimeout(() => window.scrollTo(0, scrollYBeforeLoad), 0);
					setTimeout(() => window.scrollTo(0, scrollYBeforeLoad), 150);

					this._loading = false;

				})
				.catch(() => {
					this._loading = false;
					this._button.removeAttribute('aria-disabled');
					this._button.classList.remove('is-loading');
					this._button.textContent = this.dataset.loadMoreText || 'Load More';
				});

		}

	}

	if ( typeof customElements.get('collection-load-more') == 'undefined' ) {
		customElements.define('collection-load-more', CollectionLoadMore);
	}

}
